export const partnerCourses = {
  DataAnalysis: [
    {
      id: 'partner-plus-courses/excel',
      courseID: 'excel',
      title: 'Excel',
      desc: 'Excel mastery made easy',
      img: '/Assets/navIcons/partnersNavIcons/ExcelIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/ExcelIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/excel.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/data-collection',
      courseID: 'data-collection',
      title: 'Data Collection',
      desc: 'Effective data gathering',
      img: '/Assets/navIcons/partnersNavIcons/DataCollectionIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/DataCollectionIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/data-collection.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/data-cleaning',
      courseID: 'data-cleaning',
      title: 'Data Cleaning',
      desc: 'Master the art of data refinement',
      img: '/Assets/navIcons/partnersNavIcons/DataCleaningIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/DataCleaningIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/data-cleaning.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/data-storytelling',
      courseID: 'data-storytelling',
      title: 'Data Storytelling',
      desc: 'Turn data into stories',
      img: '/Assets/navIcons/partnersNavIcons/DataStorytellingIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/DataStorytellingIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/data-storytelling.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/survey-design',
      courseID: 'survey-design',
      title: 'Survey Design',
      desc: 'Craft insightful surveys',
      img: '/Assets/navIcons/partnersNavIcons/SurveyDesignIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/SurveyDesignIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/survey-design.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/data-standardization',
      courseID: 'data-standardization',
      title: 'Data Standardization',
      desc: 'Craft precise data standards',
      img: '/Assets/navIcons/partnersNavIcons/DataStandardizationIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/DataStandardizationIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/data-standardization.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/mysql',
      courseID: 'mysql',
      title: 'MySQL',
      desc: 'Master data management with MySQL',
      img: '/Assets/navIcons/partnersNavIcons/MySQLIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/MySQLIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/mysql.png',
      pricing: { IN: '₹499' },
    },
    {
      id: 'partner-plus-courses/power-bi',
      courseID: 'power-bi',
      title: 'Power BI',
      desc: 'Visualize data effectively',
      img: '/Assets/navIcons/partnersNavIcons/PowerBIIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/PowerBIIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/power-bi.png',
      earlyAccess: true,
    },
    {
      id: 'partner-plus-courses/power-point',
      courseID: 'power-point',
      title: 'PowerPoint',
      desc: 'Bring presentations to life',
      img: '/Assets/navIcons/partnersNavIcons/PowerPointIcon.svg',
      whiteImg: '/Assets/navIcons/partnersNavIconsWhite/PowerPointIconWhite.svg',
      cardImg: '/Assets/PartnerPlusCourses/power-point.png',
      newCourse: true,
    },
  ],
};
